export const WHAT_3_WORDS = 'WHAT3WORDS';
export const TF911_PERMISSION = 'MANAGE_COMMUNICATION';
export const APPLE_ADR_PERMISSION = 'APPLE';
